import { Settings2FAContext } from "../types/Settings2FAContext";
import { Settings2FAEvent } from "../types/Settings2FAEvent";

export const clearMessageAction = (
  context: Settings2FAContext,
  event: Settings2FAEvent
): Partial<Settings2FAContext> => {
  if (!["TOGGLE", "SUBMIT_CODE"].includes(event.type)) {
    throw new Error("Invalid event type");
  }

  return {
    message: undefined,
    messageTitle: undefined,
    messageType: null,
  };
};
